import { render, staticRenderFns } from "./EmailSetting.vue?vue&type=template&id=f590ad2c"
import script from "./EmailSetting.vue?vue&type=script&lang=ts"
export * from "./EmailSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports